import { PROMO_TYPE } from '../consts';

export const constraints = {
  name: {
    presence: getPresenceConstraint('Promo Name'),
    length: getLengthConstraint('Promo Name', 100),
  },

  comment: {
    presence: getPresenceConstraint('Internal Description'),
    length: getLengthConstraint('Internal Description', 500),
  },

  limit: (fieldName: string, isPossibleDecimal: boolean) => ({
    presence: getPresenceConstraint(fieldName),
    numericality: {
      onlyInteger: !isPossibleDecimal,
      strict: true,
      greaterThanOrEqualTo: 0,
      message: `${fieldName} must be a positive ${
        isPossibleDecimal ? 'decimal' : 'int'
      } number`,
    },
  }),

  type: {
    presence: {
      allowEmpty: false,
    },
  },

  validFrom: {
    presence: {
      allowEmpty: false,
    },
  },

  validTo: {
    presence: {
      allowEmpty: false,
    },
  },

  leadRetentionFilter: {
    presence: {
      allowEmpty: false,
    },
  },

  currency: (inclusionCurrencies: any) => ({
    presence: {
      allowEmpty: false,
    },
    inclusion: inclusionCurrencies,
  }),

  visible: {
    presence: {
      allowEmpty: false,
    },
  },

  value: (type: string, minNumber: string, maxNumber: string) => {
    let typeName = '';
    let $maxNumber = '';

    switch (type) {
      case PROMO_TYPE.FIXED_BONUS:
        typeName = 'Bonus Amount';

        return {
          numericality: getNumericalConstraint(typeName),
        };
      case PROMO_TYPE.DEPOSIT_BONUS:
        typeName = 'Percent Of Bonus';

        return {
          numericality: getNumericalConstraint(typeName),
        };
      case PROMO_TYPE.DEVALUATION_BONUS:
        typeName = 'Exchange Rate';
        $maxNumber = maxNumber;
        break;
      default:
        break;
    }

    return {
      presence: getPresenceConstraint(typeName),
      numericality: getNumericalConstraint(typeName, minNumber, $maxNumber),
    };
  },

  amountFrom: () => ({
    presence: getPresenceConstraint('Deposit Amount From'),
    numericality: getNumericalConstraint('Deposit Amount From'),
  }),

  amountTo: () => ({
    presence: getPresenceConstraint('Deposit Amount To'),
    numericality: getNumericalConstraint('Deposit Amount To'),
  }),

  description: {
    length: getLengthConstraint('Description', 500),
  },

  terms: {
    length: getLengthConstraint('Terms', 500),
  },

  emailSubject: {
    length: getLengthConstraint('Subject', 100),
  },

  emailFrom: {
    length: getLengthConstraint('From', 100),
  },
};

function getPresenceConstraint(fieldName: string) {
  return {
    allowEmpty: false,
    message: `${fieldName} is required.`,
  };
}

function getLengthConstraint(fieldName: string, max: number) {
  return {
    maximum: max,
    message: `${fieldName} must be a string with a maximum length of ${max}.`,
  };
}

function getNumericalConstraint(
  fieldName: string,
  minNumber: string = '0',
  maxNumber?: string
) {
  const message = maxNumber
    ? `${fieldName} must be a positive decimal number from ${minNumber} to ${maxNumber}.`
    : `${fieldName} must be a positive decimal number.`;

  return {
    onlyInteger: false,
    greaterThanOrEqualTo: Number(minNumber),
    strict: true,
    lessThanOrEqualTo: Number(maxNumber),
    message,
  };
}
